const categoriesReducer = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default categoriesReducer;
